/* Do NOT modify this file  - Automatically generated */
window.algoliaShopify = {};
if (window.location.href.indexOf("churchsource") > -1) {
  algoliaShopify.config = {
    app_id: "0IZ6GTNJFS",
    search_api_key: "0d6b793d07cd113ac19a5747b76c2259",
    index_prefix: "Prod_CS",
    index_products: true,
    index_collections: true,
    index_articles: false,
    index_pages: true,
    sort_orders: [
      {
        key: "recently_ordered_count",
        title: "Popularity",
        desc: { active: true, title: "Most popular" },
      },
      {
        key: "title",
        title: "Name",
        asc: { active: true, title: "Title, A-Z" },
      },
      {
        key: "title",
        title: "Name",
        desc: { active: true, title: "Title, Z-A" },
      },
      {
        key: "meta.global.primary_contributor_last_name",
        title: "Author",
        asc: { active: true, title: "Author, A-Z" },
      },
      {
        key: "meta.global.primary_contributor_last_name",
        title: "Author",
        desc: { active: true, title: "Author, Z-A" },
      },
      {
        key: "price",
        title: "Price",
        asc: { active: true, title: "Price, Low - High" },
      },
      {
        key: "price",
        title: "Price",
        desc: { active: true, title: "Price, High - Low" },
      },
      {
        key: "meta.global.publish_date_timestamp",
        title: "Publication date",
        asc: { active: true, title: "Oldest - Newest" },
      },
      {
        key: "meta.global.publish_date_timestamp",
        title: "Publication date",
        desc: { active: true, title: "Newest - Oldest" },
      },
      {
        key: "price_ratio",
        title: "Price ratio",
        asc: { active: false, title: "Highest discount first" },
      },
      {
        key: "inventory_quantity",
        title: "Inventory quantity",
        desc: { active: false, title: "Most available" },
      },
      {
        key: "grams",
        title: "Weight",
        asc: { active: false, title: "Lightest first" },
      },
    ],
    facets: [
      {
        enabled: true,
        name: "price_range",
        title: "Price range",
        type: "disjunctive",
        available_types: ["disjunctive"],
        forgettable: null,
        searchable: false,
        refined_first: false,
      },
      {
        enabled: true,
        name: "vendor",
        title: "Author",
        type: "disjunctive",
        available_types: ["menu", "conjunctive", "disjunctive"],
        forgettable: null,
        searchable: false,
        refined_first: false,
      },
      {
        enabled: true,
        name: "meta.global.publisher",
        title: "Publisher",
        type: "disjunctive",
        available_types: ["menu", "slider", "conjunctive", "disjunctive"],
        forgettable: null,
        searchable: false,
        refined_first: true,
      },
      {
        enabled: true,
        name: "options.format",
        title: "Format",
        type: "disjunctive",
        available_types: ["conjunctive", "disjunctive", "slider"],
        forgettable: true,
        searchable: true,
        refined_first: false,
      },
      {
        enabled: true,
        name: "meta.global.pointsize",
        title: "Print size",
        type: "slider",
        available_types: ["slider", "conjunctive", "disjunctive", "menu"],
        forgettable: null,
        searchable: true,
        refined_first: false,
        removeAble: true
      },
      {
        enabled: true,
        name: "options.color",
        title: "Color",
        type: "disjunctive",
        available_types: ["conjunctive", "disjunctive", "slider"],
        forgettable: true,
        searchable: true,
        refined_first: false,
      },
      {
        enabled: true,
        name: "meta.global.translation",
        title: "Translation",
        type: "disjunctive",
        available_types: ["menu", "slider", "conjunctive", "disjunctive"],
        forgettable: null,
        searchable: true,
        refined_first: true,
      },
      {
        enabled: true,
        name: "options.thumb_index",
        title: "Thumb index",
        type: "disjunctive",
        available_types: ["conjunctive", "disjunctive", "slider"],
        forgettable: true,
        searchable: true,
        refined_first: false,
      },
      {
        enabled: true,
        name: "meta.yotpo.reviews_average",
        title: "Review Rating",
        type: "conjunctive",
        available_types: ["menu", "slider", "conjunctive", "disjunctive"],
        forgettable: null,
        searchable: false,
        refined_first: true,
      },
      {
        enabled: false,
        name: "tags",
        title: "Tags",
        type: "conjunctive",
        available_types: ["menu", "conjunctive", "disjunctive"],
        forgettable: null,
        searchable: false,
        refined_first: false,
      },
      {
        enabled: false,
        name: "product_type",
        title: "Type",
        type: "conjunctive",
        available_types: ["menu", "conjunctive", "disjunctive"],
        forgettable: null,
        searchable: false,
        refined_first: false,
      },
      {
        enabled: false,
        name: "price",
        title: "Price",
        type: "slider",
        available_types: ["slider"],
        forgettable: null,
        searchable: false,
        refined_first: false,
      },
      {
        enabled: true,
        name: "named_tags.Series",
        title: "Series",
        type: "hidden",
        available_types: ["conjunctive", "disjunctive", "slider"],
        forgettable: true,
        searchable: true,
        refined_first: false,
      },
      {
        title: "Format",
        name: "meta.global.format",
        enabled: false,
        type: "conjunctive",
        available_types: ["menu", "slider", "conjunctive", "disjunctive"],
        refined_first: true,
      },
    ],
    powered_by: false,
    autocomplete_see_all: false,
    colors: { main: "#3d4246", secondary: "#69727b", highlight: "#c45929" },
    autocomplete_enabled: true,
    autocomplete_debug: false,
    input_selector:
      'form[action="/search"] input[type="text"], form[action="/search"] input[type="search"]',
    products_autocomplete_hits_per_page: 8,
    collections_autocomplete_hits_per_page: 2,
    articles_autocomplete_hits_per_page: 2,
    pages_autocomplete_hits_per_page: 2,
    instant_search_enabled: true,
    instant_search_enabled_on_collection: true,
    results_selector: "#algolia-page",
    products_full_results_hits_per_page: 18,
    collections_full_results_hits_per_page: 18,
    show_products: true,
    analytics_enabled: true,
    collection_id_indexing: true,
    collection_id_query_rules: false,
    collection_search_feature_enabled: true,
    collection_css_selector: "#algolia-page",
    collection_facets: {
      default: [
        {
          enabled: true,
          name: "price_range",
          title: "Price range",
          type: "disjunctive",
          available_types: ["disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: true,
          name: "vendor",
          title: "Author",
          type: "disjunctive",
          available_types: ["menu", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: true,
          name: "named_tags.Pub Group",
          title: "Pub Group",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: true,
          name: "meta.global.pointsize",
          title: "Print size",
          type: "slider",
          available_types: ["slider", "conjunctive", "disjunctive", "menu"],
          forgettable: null,
          searchable: true,
          refined_first: false,
          removeAble: true
        },
        {
          enabled: true,
          name: "options.format",
          title: "Format",
          type: "disjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: true,
          name: "options.color",
          title: "Color",
          type: "disjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: true,
          name: "meta.global.translation",
          title: "Translation",
          type: "disjunctive",
          available_types: ["menu", "slider", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: true,
          name: "options.thumb_index",
          title: "Thumb index",
          type: "disjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: true,
          name: "meta.yotpo.reviews_average",
          title: "Review Rating",
          type: "conjunctive",
          available_types: ["menu", "slider", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: false,
          name: "options.material",
          title: "Material",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: false,
          name: "named_tags.custom-related-products",
          title: "Custom-related-products",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: false,
          name: "price",
          title: "Price",
          type: "slider",
          available_types: ["slider"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: false,
          name: "tags",
          title: "Tags",
          type: "conjunctive",
          available_types: ["menu", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: false,
          name: "product_type",
          title: "Type",
          type: "conjunctive",
          available_types: ["menu", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: false,
          name: "options.size",
          title: "Size",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: false,
          name: "named_tags.Series",
          title: "Series",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: false,
          name: "meta.global.publisher",
          title: "Publisher",
          type: "disjunctive",
          available_types: ["menu", "slider", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: false,
          name: "options.binding",
          title: "Binding",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          title: "Format",
          name: "meta.global.format",
          enabled: false,
          type: "conjunctive",
          available_types: ["menu", "slider", "conjunctive", "disjunctive"],
          refined_first: true,
        },
      ],
      80730259525: [
        {
          enabled: true,
          name: "price_range",
          title: "Price range",
          type: "disjunctive",
          available_types: ["disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: true,
          name: "meta.global.publisher",
          title: "Publisher",
          type: "disjunctive",
          available_types: ["menu", "slider", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: true,
          name: "meta.global.pointsize",
          title: "Print size",
          type: "slider",
          available_types: ["slider", "conjunctive", "disjunctive", "menu"],
          forgettable: null,
          searchable: true,
          refined_first: false,
          removeAble: true
        },
        {
          enabled: true,
          name: "options.format",
          title: "Format",
          type: "disjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: true,
          name: "options.color",
          title: "Color",
          type: "disjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: true,
          name: "meta.global.translation",
          title: "Translation",
          type: "disjunctive",
          available_types: ["menu", "slider", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: true,
          name: "options.thumb_index",
          title: "Thumb index",
          type: "disjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: true,
          name: "meta.yotpo.reviews_average",
          title: "Review Rating",
          type: "conjunctive",
          available_types: ["menu", "slider", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: false,
          name: "options.material",
          title: "Material",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: false,
          name: "named_tags.custom-related-products",
          title: "Custom-related-products",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: false,
          name: "named_tags.Pub Group",
          title: "Pub Group",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: false,
          name: "price",
          title: "Price",
          type: "slider",
          available_types: ["slider"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: false,
          name: "tags",
          title: "Tags",
          type: "conjunctive",
          available_types: ["menu", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: false,
          name: "product_type",
          title: "Type",
          type: "conjunctive",
          available_types: ["menu", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: false,
          name: "options.size",
          title: "Size",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: false,
          name: "named_tags.Series",
          title: "Series",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: false,
          name: "vendor",
          title: "Author",
          type: "disjunctive",
          available_types: ["menu", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: false,
          name: "options.binding",
          title: "Binding",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          title: "Format",
          name: "meta.global.format",
          enabled: false,
          type: "conjunctive",
          available_types: ["menu", "slider", "conjunctive", "disjunctive"],
          refined_first: true,
        },
      ],
    },
    collection_sort_orders: {
      default: [
        {
          key: "recently_ordered_count",
          title: "Popularity",
          desc: { active: true, title: "Most popular" },
        },
        {
          key: "title",
          title: "Name",
          asc: { active: true, title: "Title, A-Z" },
        },
        {
          key: "title",
          title: "Name",
          desc: { active: true, title: "Title, Z-A" },
        },
        {
          key: "meta.global.primary_contributor_last_name",
          title: "Author",
          asc: { active: true, title: "Author, A-Z" },
        },
        {
          key: "meta.global.primary_contributor_last_name",
          title: "Author",
          desc: { active: true, title: "Author, Z-A" },
        },
        {
          key: "price",
          title: "Price",
          asc: { active: true, title: "Price, Low - High" },
        },
        {
          key: "price",
          title: "Price",
          desc: { active: true, title: "Price, High - Low" },
        },
        {
          key: "meta.global.publish_date_timestamp",
          title: "Publication date",
          asc: { active: true, title: "Oldest - Newest" },
        },
        {
          key: "meta.global.publish_date_timestamp",
          title: "Publication date",
          desc: { active: true, title: "Newest - Oldest" },
        },
        {
          key: "price_ratio",
          title: "Price ratio",
          asc: { active: false, title: "Highest discount first" },
        },
        {
          key: "inventory_quantity",
          title: "Inventory quantity",
          desc: { active: false, title: "Most available" },
        },
        {
          key: "grams",
          title: "Weight",
          asc: { active: false, title: "Lightest first" },
        },
      ],
      80730259525: [
        {
          key: "recently_ordered_count",
          title: "Popularity",
          desc: { active: true, title: "Most popular" },
        },
        {
          key: "title",
          title: "Name",
          asc: { active: true, title: "Title, A-Z" },
        },
        {
          key: "title",
          title: "Name",
          desc: { active: true, title: "Title, Z-A" },
        },
        {
          key: "price",
          title: "Price",
          asc: { active: true, title: "Price, Low - High" },
        },
        {
          key: "price",
          title: "Price",
          desc: { active: true, title: "Price, High - Low" },
        },
        {
          key: "meta.global.publish_date_timestamp",
          title: "Publication date",
          desc: { active: true, title: "Newest - Oldest" },
        },
        {
          key: "meta.global.publish_date_timestamp",
          title: "Publication date",
          asc: { active: true, title: "Oldest - Newest" },
        },
        {
          key: "price_ratio",
          title: "Price ratio",
          asc: { active: false, title: "Highest discount first" },
        },
        {
          key: "inventory_quantity",
          title: "Inventory quantity",
          desc: { active: false, title: "Most available" },
        },
        {
          key: "meta.global.primary_contributor_last_name",
          title: "Author",
          desc: { active: false, title: "Author, Z-A" },
        },
        {
          key: "meta.global.primary_contributor_last_name",
          title: "Author",
          asc: { active: false, title: "Author, A-Z" },
        },
        {
          key: "grams",
          title: "Weight",
          asc: { active: false, title: "Lightest first" },
        },
      ],
    },
    stock_policy: "allow",
  };
} else if (window.location.href.indexOf("thefoyer") > -1) {
  algoliaShopify.config = {
    app_id: "0IZ6GTNJFS",
    search_api_key: "0102424a9e77a606e0f1f1a920fb4922",
    index_prefix: "PROD_FOY",
    index_products: true,
    index_collections: true,
    index_articles: false,
    index_pages: true,
    sort_orders: [
      {
        key: "recently_ordered_count",
        title: "Popularity",
        desc: { active: true, title: "Most popular" },
      },
      {
        key: "title",
        title: "Name",
        asc: { active: true, title: "Title, A-Z" },
      },
      {
        key: "title",
        title: "Name",
        desc: { active: true, title: "Title, Z-A" },
      },
      {
        key: "meta.global.primary_contributor_last_name",
        title: "Author",
        asc: { active: true, title: "Author, A-Z" },
      },
      {
        key: "meta.global.primary_contributor_last_name",
        title: "Author",
        desc: { active: true, title: "Author, Z-A" },
      },
      {
        key: "price",
        title: "Price",
        asc: { active: true, title: "Price, Low - High" },
      },
      {
        key: "price",
        title: "Price",
        desc: { active: true, title: "Price, High - Low" },
      },
      {
        key: "meta.global.publish_date_timestamp",
        title: "Publication date",
        desc: { active: true, title: "Newest - Oldest" },
      },
      {
        key: "meta.global.publish_date_timestamp",
        title: "Publication date",
        asc: { active: true, title: "Oldest - Newest" },
      },
      {
        key: "price_ratio",
        title: "Price ratio",
        asc: { active: false, title: "Highest discount first" },
      },
      {
        key: "inventory_quantity",
        title: "Inventory quantity",
        desc: { active: false, title: "Most available" },
      },
      {
        key: "grams",
        title: "Weight",
        asc: { active: false, title: "Lightest first" },
      },
    ],
    facets: [
      {
        enabled: true,
        name: "price_range",
        title: "Price range",
        type: "disjunctive",
        available_types: ["disjunctive"],
        forgettable: null,
        searchable: false,
        refined_first: false,
      },
      {
        enabled: true,
        name: "vendor",
        title: "Author",
        type: "disjunctive",
        available_types: ["menu", "conjunctive", "disjunctive"],
        forgettable: null,
        searchable: false,
        refined_first: false,
      },
      {
        enabled: true,
        name: "meta.global.publisher",
        title: "Publisher",
        type: "disjunctive",
        available_types: ["menu", "slider", "conjunctive", "disjunctive"],
        forgettable: null,
        searchable: false,
        refined_first: true,
      },
      {
        enabled: true,
        name: "options.format",
        title: "Format",
        type: "disjunctive",
        available_types: ["conjunctive", "disjunctive", "slider"],
        forgettable: true,
        searchable: true,
        refined_first: false,
      },
      {
        enabled: true,
        name: "options.color",
        title: "Color",
        type: "disjunctive",
        available_types: ["conjunctive", "disjunctive", "slider"],
        forgettable: true,
        searchable: true,
        refined_first: false,
      },
      {
        enabled: true,
        name: "meta.global.translation",
        title: "Translation",
        type: "disjunctive",
        available_types: ["menu", "slider", "conjunctive", "disjunctive"],
        forgettable: null,
        searchable: true,
        refined_first: true,
      },
      {
        enabled: true,
        name: "options.thumb_index",
        title: "Thumb index",
        type: "disjunctive",
        available_types: ["conjunctive", "disjunctive", "slider"],
        forgettable: true,
        searchable: true,
        refined_first: false,
      },
      {
        enabled: true,
        name: "meta.yotpo.reviews_average",
        title: "Review Rating",
        type: "conjunctive",
        available_types: ["menu", "slider", "conjunctive", "disjunctive"],
        forgettable: null,
        searchable: false,
        refined_first: true,
      },
      {
        enabled: false,
        name: "product_type",
        title: "Type",
        type: "conjunctive",
        available_types: ["menu", "conjunctive", "disjunctive"],
        forgettable: null,
        searchable: false,
        refined_first: false,
      },
      {
        enabled: false,
        name: "tags",
        title: "Tags",
        type: "conjunctive",
        available_types: ["menu", "conjunctive", "disjunctive"],
        forgettable: null,
        searchable: false,
        refined_first: false,
      },
      {
        enabled: false,
        name: "price",
        title: "Price",
        type: "slider",
        available_types: ["slider"],
        forgettable: null,
        searchable: false,
        refined_first: false,
      },
      {
        enabled: true,
        name: "named_tags.Series",
        title: "Series",
        type: "hidden",
        available_types: ["conjunctive", "disjunctive", "slider"],
        forgettable: true,
        searchable: true,
        refined_first: false,
      },
      {
        title: "Format",
        name: "meta.global.format",
        enabled: false,
        type: "conjunctive",
        available_types: ["menu", "slider", "conjunctive", "disjunctive"],
        refined_first: true,
      },
    ],
    powered_by: false,
    autocomplete_see_all: false,
    colors: { main: "#3d4246", secondary: "#69727b", highlight: "#1E0052" },
    autocomplete_enabled: true,
    autocomplete_debug: false,
    input_selector:
      'form[action="/search"] input[type="text"], form[action="/search"] input[type="search"]',
    products_autocomplete_hits_per_page: 8,
    collections_autocomplete_hits_per_page: 2,
    articles_autocomplete_hits_per_page: 2,
    pages_autocomplete_hits_per_page: 2,
    instant_search_enabled: true,
    instant_search_enabled_on_collection: true,
    results_selector: "#algolia-page",
    products_full_results_hits_per_page: 18,
    collections_full_results_hits_per_page: 18,
    show_products: true,
    analytics_enabled: true,
    collection_id_indexing: true,
    collection_id_query_rules: false,
    collection_search_feature_enabled: true,
    collection_css_selector: "#algolia-page",
    collection_facets: {
      default: [
        {
          enabled: true,
          name: "price_range",
          title: "Price range",
          type: "disjunctive",
          available_types: ["disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: true,
          name: "vendor",
          title: "Author",
          type: "disjunctive",
          available_types: ["menu", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: true,
          name: "meta.global.publisher",
          title: "Publisher",
          type: "conjunctive",
          available_types: ["menu", "slider", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: true,
          name: "options.format",
          title: "Format",
          type: "disjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: true,
          name: "options.color",
          title: "Color",
          type: "disjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: true,
          name: "meta.global.translation",
          title: "Translation",
          type: "disjunctive",
          available_types: ["menu", "slider", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: true,
          name: "options.thumb_index",
          title: "Thumb index",
          type: "disjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: true,
          name: "meta.yotpo.reviews_average",
          title: "Review Rating",
          type: "conjunctive",
          available_types: ["menu", "slider", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: false,
          name: "named_tags.Series",
          title: "Series",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: false,
          name: "named_tags.Pub Group",
          title: "Pub Group",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: false,
          name: "price",
          title: "Price",
          type: "slider",
          available_types: ["slider"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: false,
          name: "product_type",
          title: "Type",
          type: "conjunctive",
          available_types: ["menu", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: false,
          name: "tags",
          title: "Tags",
          type: "conjunctive",
          available_types: ["menu", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: false,
          name: "options.binding",
          title: "Binding",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: false,
          name: "options.material",
          title: "Material",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: false,
          name: "options.size",
          title: "Size",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          title: "Format",
          name: "meta.global.format",
          enabled: false,
          type: "conjunctive",
          available_types: ["menu", "slider", "conjunctive", "disjunctive"],
          refined_first: true,
        },
      ],
    },
    collection_sort_orders: {
      default: [
        {
          key: "recently_ordered_count",
          title: "Popularity",
          desc: { active: true, title: "Most popular" },
        },
        {
          key: "title",
          title: "Name",
          asc: { active: true, title: "Title, A-Z" },
        },
        {
          key: "title",
          title: "Name",
          desc: { active: true, title: "Title, Z-A" },
        },
        {
          key: "meta.global.primary_contributor_last_name",
          title: "Author",
          asc: { active: true, title: "Author, A-Z" },
        },
        {
          key: "meta.global.primary_contributor_last_name",
          title: "Author",
          desc: { active: true, title: "Author, Z-A" },
        },
        {
          key: "price",
          title: "Price",
          asc: { active: true, title: "Price, Low - High" },
        },
        {
          key: "price",
          title: "Price",
          desc: { active: true, title: "Price, High - Low" },
        },
        {
          key: "meta.global.publish_date_timestamp",
          title: "Publication date",
          desc: { active: true, title: "Newest - Oldest" },
        },
        {
          key: "meta.global.publish_date_timestamp",
          title: "Publication date",
          asc: { active: true, title: "Oldest - Newest" },
        },
        {
          key: "price_ratio",
          title: "Price ratio",
          asc: { active: false, title: "Highest discount first" },
        },
        {
          key: "inventory_quantity",
          title: "Inventory quantity",
          desc: { active: false, title: "Most available" },
        },
        {
          key: "grams",
          title: "Weight",
          asc: { active: false, title: "Lightest first" },
        },
      ],
    },
    stock_policy: "allow",
  };
} else {
  algoliaShopify.config = {
    app_id: "0IZ6GTNJFS",
    search_api_key: "0d6b793d07cd113ac19a5747b76c2259",
    index_prefix: "PROD_FG",
    index_products: true,
    index_collections: true,
    index_articles: false,
    index_pages: true,
    sort_orders: [
      {
        key: "recently_ordered_count",
        title: "Popularity",
        desc: { active: true, title: "Most popular" },
      },
      {
        key: "title",
        title: "Name",
        asc: { active: true, title: "Title, A-Z" },
      },
      {
        key: "title",
        title: "Name",
        desc: { active: true, title: "Title, Z-A" },
      },
      {
        key: "meta.global.primary_contributor_last_name",
        title: "Author",
        asc: { active: true, title: "Author, A-Z" },
      },
      {
        key: "meta.global.primary_contributor_last_name",
        title: "Author",
        desc: { active: true, title: "Author, Z-A" },
      },
      {
        key: "price",
        title: "Price",
        asc: { active: true, title: "Price, Low - High" },
      },
      {
        key: "price",
        title: "Price",
        desc: { active: true, title: "Price, High - Low" },
      },
      {
        key: "meta.global.publish_date_timestamp",
        title: "Publication date",
        desc: { active: true, title: "Newest - Oldest" },
      },
      {
        key: "meta.global.publish_date_timestamp",
        title: "Publication date",
        asc: { active: true, title: "Oldest - Newest" },
      },
      {
        key: "price_ratio",
        title: "Price ratio",
        asc: { active: false, title: "Highest discount first" },
      },
      {
        key: "inventory_quantity",
        title: "Inventory quantity",
        desc: { active: false, title: "Most available" },
      },
      {
        key: "grams",
        title: "Weight",
        asc: { active: false, title: "Lightest first" },
      },
    ],
    facets: [
      {
        enabled: true,
        name: "price_range",
        title: "Price range",
        type: "disjunctive",
        available_types: ["disjunctive"],
        forgettable: null,
        searchable: false,
        refined_first: false,
      },
      {
        enabled: true,
        name: "vendor",
        title: "Author",
        type: "disjunctive",
        available_types: ["menu", "conjunctive", "disjunctive"],
        forgettable: null,
        searchable: false,
        refined_first: false,
      },
      {
        enabled: true,
        name: "meta.global.publisher",
        title: "Publisher",
        type: "disjunctive",
        available_types: ["menu", "slider", "conjunctive", "disjunctive"],
        forgettable: null,
        searchable: false,
        refined_first: true,
      },
      {
        enabled: true,
        name: "meta.global.pointsize",
        title: "Print size",
        type: "slider",
        available_types: ["slider", "conjunctive", "disjunctive", "menu"],
        forgettable: null,
        searchable: true,
        refined_first: false,
        removeAble: true
      },
      {
        enabled: true,
        name: "options.format",
        title: "Format",
        type: "disjunctive",
        available_types: ["conjunctive", "disjunctive", "slider"],
        forgettable: true,
        searchable: true,
        refined_first: false,
      },
      {
        enabled: true,
        name: "options.color",
        title: "Color",
        type: "disjunctive",
        available_types: ["conjunctive", "disjunctive", "slider"],
        forgettable: true,
        searchable: true,
        refined_first: false,
      },
      {
        enabled: true,
        name: "meta.global.translation",
        title: "Translation",
        type: "disjunctive",
        available_types: ["menu", "slider", "conjunctive", "disjunctive"],
        forgettable: null,
        searchable: true,
        refined_first: true,
      },
      {
        enabled: true,
        name: "options.thumb_index",
        title: "Thumb index",
        type: "disjunctive",
        available_types: ["conjunctive", "disjunctive", "slider"],
        forgettable: true,
        searchable: true,
        refined_first: false,
      },
      {
        enabled: true,
        name: "meta.yotpo.reviews_average",
        title: "Review Rating",
        type: "conjunctive",
        available_types: ["menu", "slider", "conjunctive", "disjunctive"],
        forgettable: null,
        searchable: false,
        refined_first: true,
      },
      {
        enabled: false,
        name: "product_type",
        title: "Type",
        type: "conjunctive",
        available_types: ["menu", "conjunctive", "disjunctive"],
        forgettable: null,
        searchable: false,
        refined_first: false,
      },
      {
        enabled: false,
        name: "tags",
        title: "Tags",
        type: "conjunctive",
        available_types: ["menu", "conjunctive", "disjunctive"],
        forgettable: null,
        searchable: false,
        refined_first: false,
      },
      {
        enabled: false,
        name: "price",
        title: "Price",
        type: "slider",
        available_types: ["slider"],
        forgettable: null,
        searchable: false,
        refined_first: false,
      },
      {
        enabled: true,
        name: "named_tags.Series",
        title: "Series",
        type: "hidden",
        available_types: ["conjunctive", "disjunctive", "slider"],
        forgettable: true,
        searchable: true,
        refined_first: false,
      },
      {
        title: "Format",
        name: "meta.global.format",
        enabled: false,
        type: "conjunctive",
        available_types: ["menu", "slider", "conjunctive", "disjunctive"],
        refined_first: true,
      },
    ],
    powered_by: false,
    autocomplete_see_all: false,
    colors: { main: "#3d4246", secondary: "#69727b", highlight: "#cb0100" },
    autocomplete_enabled: true,
    autocomplete_debug: false,
    input_selector:
      'form[action="/search"] input[type="text"], form[action="/search"] input[type="search"]',
    products_autocomplete_hits_per_page: 8,
    collections_autocomplete_hits_per_page: 2,
    articles_autocomplete_hits_per_page: 2,
    pages_autocomplete_hits_per_page: 2,
    instant_search_enabled: true,
    instant_search_enabled_on_collection: true,
    results_selector: "#algolia-page",
    products_full_results_hits_per_page: 18,
    collections_full_results_hits_per_page: 18,
    show_products: true,
    analytics_enabled: true,
    collection_id_indexing: true,
    collection_id_query_rules: false,
    collection_search_feature_enabled: true,
    collection_css_selector: "#algolia-page",
    collection_facets: {
      default: [
        {
          enabled: true,
          name: "price_range",
          title: "Price range",
          type: "disjunctive",
          available_types: ["disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: true,
          name: "vendor",
          title: "Author",
          type: "disjunctive",
          available_types: ["menu", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: true,
          name: "meta.global.publisher",
          title: "Publisher",
          type: "conjunctive",
          available_types: ["menu", "slider", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: true,
          name: "meta.global.pointsize",
          title: "Print size",
          type: "slider",
          available_types: ["slider"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: true,
          name: "options.format",
          title: "Format",
          type: "disjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: true,
          name: "options.color",
          title: "Color",
          type: "disjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: true,
          name: "meta.global.translation",
          title: "Translation",
          type: "disjunctive",
          available_types: ["menu", "slider", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: true,
          name: "options.thumb_index",
          title: "Thumb index",
          type: "disjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: true,
          name: "meta.yotpo.reviews_average",
          title: "Review Rating",
          type: "conjunctive",
          available_types: ["menu", "slider", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: false,
          name: "named_tags.Series",
          title: "Series",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: false,
          name: "named_tags.Pub Group",
          title: "Pub Group",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: false,
          name: "price",
          title: "Price",
          type: "slider",
          available_types: ["slider"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: false,
          name: "product_type",
          title: "Type",
          type: "conjunctive",
          available_types: ["menu", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: false,
          name: "tags",
          title: "Tags",
          type: "conjunctive",
          available_types: ["menu", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: false,
          name: "options.binding",
          title: "Binding",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: false,
          name: "options.material",
          title: "Material",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: false,
          name: "options.size",
          title: "Size",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          title: "Format",
          name: "meta.global.format",
          enabled: false,
          type: "conjunctive",
          available_types: ["menu", "slider", "conjunctive", "disjunctive"],
          refined_first: true,
        },
      ],
      82469945455: [
        {
          enabled: true,
          name: "price_range",
          title: "Price range",
          type: "disjunctive",
          available_types: ["disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: true,
          name: "vendor",
          title: "Author",
          type: "disjunctive",
          available_types: ["menu", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: true,
          name: "meta.global.publisher",
          title: "Publisher",
          type: "conjunctive",
          available_types: ["menu", "slider", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: true,
          name: "meta.global.pointsize",
          title: "Print size",
          type: "slider",
          available_types: ["slider", "conjunctive", "disjunctive", "menu"],
          forgettable: null,
          searchable: true,
          refined_first: false,
          removeAble: true
        },
        {
          enabled: true,
          name: "options.format",
          title: "Format",
          type: "disjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: true,
          name: "options.color",
          title: "Color",
          type: "disjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: true,
          name: "meta.global.translation",
          title: "Translation",
          type: "disjunctive",
          available_types: ["menu", "slider", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: true,
          name: "options.thumb_index",
          title: "Thumb index",
          type: "disjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: true,
          name: "meta.yotpo.reviews_average",
          title: "Review Rating",
          type: "conjunctive",
          available_types: ["menu", "slider", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: false,
          name: "named_tags.Series",
          title: "Series",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: false,
          name: "named_tags.Pub Group",
          title: "Pub Group",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: false,
          name: "price",
          title: "Price",
          type: "slider",
          available_types: ["slider"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: false,
          name: "product_type",
          title: "Type",
          type: "conjunctive",
          available_types: ["menu", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: false,
          name: "tags",
          title: "Tags",
          type: "conjunctive",
          available_types: ["menu", "conjunctive", "disjunctive"],
          forgettable: null,
          searchable: false,
          refined_first: false,
        },
        {
          enabled: false,
          name: "options.binding",
          title: "Binding",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: false,
          name: "options.material",
          title: "Material",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          enabled: false,
          name: "options.size",
          title: "Size",
          type: "conjunctive",
          available_types: ["conjunctive", "disjunctive", "slider"],
          forgettable: true,
          searchable: true,
          refined_first: false,
        },
        {
          title: "Format",
          name: "meta.global.format",
          enabled: false,
          type: "conjunctive",
          available_types: ["menu", "slider", "conjunctive", "disjunctive"],
          refined_first: true,
        },
      ],
    },
    collection_sort_orders: {
      default: [
        {
          key: "recently_ordered_count",
          title: "Popularity",
          desc: { active: true, title: "Most popular" },
        },
        {
          key: "title",
          title: "Name",
          asc: { active: true, title: "Title, A-Z" },
        },
        {
          key: "title",
          title: "Name",
          desc: { active: true, title: "Title, Z-A" },
        },
        {
          key: "meta.global.primary_contributor_last_name",
          title: "Author",
          asc: { active: true, title: "Author, A-Z" },
        },
        {
          key: "meta.global.primary_contributor_last_name",
          title: "Author",
          desc: { active: true, title: "Author, Z-A" },
        },
        {
          key: "price",
          title: "Price",
          asc: { active: true, title: "Price, Low - High" },
        },
        {
          key: "price",
          title: "Price",
          desc: { active: true, title: "Price, High - Low" },
        },
        {
          key: "meta.global.publish_date_timestamp",
          title: "Publication date",
          desc: { active: true, title: "Newest - Oldest" },
        },
        {
          key: "meta.global.publish_date_timestamp",
          title: "Publication date",
          asc: { active: true, title: "Oldest - Newest" },
        },
        {
          key: "price_ratio",
          title: "Price ratio",
          asc: { active: false, title: "Highest discount first" },
        },
        {
          key: "inventory_quantity",
          title: "Inventory quantity",
          desc: { active: false, title: "Most available" },
        },
        {
          key: "grams",
          title: "Weight",
          asc: { active: false, title: "Lightest first" },
        },
      ],
      82469945455: [
        {
          key: "recently_ordered_count",
          title: "Popularity",
          desc: { active: true, title: "Most popular" },
        },
        {
          key: "title",
          title: "Name",
          asc: { active: true, title: "Title, A-Z" },
        },
        {
          key: "title",
          title: "Name",
          desc: { active: true, title: "Title, Z-A" },
        },
        {
          key: "meta.global.primary_contributor_last_name",
          title: "Author",
          asc: { active: true, title: "Author, A-Z" },
        },
        {
          key: "meta.global.primary_contributor_last_name",
          title: "Author",
          desc: { active: true, title: "Author, Z-A" },
        },
        {
          key: "price",
          title: "Price",
          asc: { active: true, title: "Price, Low - High" },
        },
        {
          key: "price",
          title: "Price",
          desc: { active: true, title: "Price, High - Low" },
        },
        {
          key: "meta.global.publish_date_timestamp",
          title: "Publication date",
          desc: { active: true, title: "Newest - Oldest" },
        },
        {
          key: "meta.global.publish_date_timestamp",
          title: "Publication date",
          asc: { active: true, title: "Oldest - Newest" },
        },
        {
          key: "price_ratio",
          title: "Price ratio",
          asc: { active: false, title: "Highest discount first" },
        },
        {
          key: "inventory_quantity",
          title: "Inventory quantity",
          desc: { active: false, title: "Most available" },
        },
        {
          key: "grams",
          title: "Weight",
          asc: { active: false, title: "Lightest first" },
        },
      ],
    },
    stock_policy: "allow",
  };
}
